import service from "./service"

const submitPreAdverseActionResponse = async (data) => {
    return service(data)
}

export default submitPreAdverseActionResponse
